var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37598 1.04175C11.0115 1.0418 13.9618 3.94236 13.9619 7.49683C13.9619 11.0514 11.0116 13.9518 7.37598 13.9519C3.74031 13.9519 0.790039 11.0514 0.790039 7.49683C0.790156 3.94232 3.74038 1.04175 7.37598 1.04175ZM7.37598 1.573C4.0418 1.573 1.34191 4.21471 1.3418 7.49683C1.3418 10.779 4.04172 13.4207 7.37598 13.4207C10.7102 13.4206 13.4102 10.779 13.4102 7.49683C13.41 4.21474 10.7101 1.57305 7.37598 1.573Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1694 4.89368L10.7632 5.53821L10.7944 5.57141L10.7632 5.60559L6.34717 10.3947L6.31104 10.4337L6.27393 10.3947L3.89893 7.81946L3.86768 7.78528L3.89893 7.7511L4.49268 7.10754L4.52979 7.0675L4.56689 7.10754L6.31006 8.99915L10.0962 4.89368L10.1333 4.85364L10.1694 4.89368Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlined);
export default __webpack_public_path__ + "static/media/checkOutlined.9fdfeb28fa8e9c1fa40a56eeb34fdd3b.svg";
export { ForwardRef as ReactComponent };